import { render, staticRenderFns } from "./CalculatorResults.vue?vue&type=template&id=e327e548&scoped=true&"
import script from "./CalculatorResults.vue?vue&type=script&lang=js&"
export * from "./CalculatorResults.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorResults.vue?vue&type=style&index=0&id=e327e548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e327e548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VIcon,VSimpleTable})
